import { ApiPath } from "enums";
import { Get, Post } from "utils";

export const createChatThread = async ({ campaignCode }) => {
  const res = await Post(ApiPath.SurveyChatThread, { campaignCode });
  return res.data;
};

export const getChatThreads = async ({ campaignCode, page = 1, perPage = 20 } = {}) => {
  const res = await Get(ApiPath.SurveyChatThread, {
    campaignCode,
    page,
    perPage,
  });
  return res.data;
};

export const getChatThreadMessages = async ({ insightChatThreadId, page = 1, perPage = 20 }) => {
  const res = await Get(`${ApiPath.SurveyChatThread}/${insightChatThreadId}/message`, {
    page,
    perPage,
  });
  return res.data;
};

export const createChatThreadMessage = async ({ insightChatThreadId, prompt }) => {
  const res = await Post(`${ApiPath.SurveyChatThread}/${insightChatThreadId}/message`, { prompt });
  return res.data;
};
